export function getFuseSearchResult(value, fuse) {
    if (!value.length || !fuse) {
        return undefined;
    }
    var searchStr = value;
    if (value.startsWith('*')) {
        searchStr = "".concat(value.replace('*', ''), "$");
    }
    else if (value.endsWith('*')) {
        searchStr = "^".concat(value.replace('*', ''));
    }
    else if (value.includes(',')) {
        searchStr = "".concat(value
            .split(',')
            .map(function (v) { return v.trim(); })
            .join('|'));
    }
    var results = fuse.search(searchStr);
    return results.map(function (_a) {
        var item = _a.item;
        return item;
    });
}
